import { ClearRounded } from "@mui/icons-material";
import { Divider, Grid, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import Products from "./Products";
import Footer from "./Footer";
import CustomerAndUser from "./CustomerAndUser";
import { action, API, controller } from "../../../../../api/api";

const ViewQuote = ({
  setShowForm,
  handleView,
  id,
  setQuotes,
  handleContinuSale,
}) => {
  const [value, setValue] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (id) {
      API(controller.QuoteSale + action.GetById).getById(id, (res) => {
        res &&
          res.status === 200 &&
          res.result.id &&
          setValue({ ...res.result });
        setLoading(false);
      });
    }

    return () => {};
  }, [id]);

  const handleClose = () => {
    setShowForm(false);
  };

  return !loading && value ? (
    <div>
      <div className="flex justify-between items-center p-[10px] pb-[5px]">
        <div>
          <span className="text-[20px] mb-[5px] font-medium text-gray-500 uppercase ">
            Quote details
          </span>
        </div>

        <div>
          <IconButton onClick={handleClose} size="small" className="mr-[5px]">
            <ClearRounded className="text-[20px] m-[2px]" />
          </IconButton>
        </div>
      </div>
      <Divider />
      <div className="p-[20px]">
        <Grid container spacing={2}>
          {/* ----- Customer and Served User Details ----- */}
          <CustomerAndUser value={value} />
          {/* ------ Sale Product Details ------- */}
          <Products
            {...{
              value,
              handleView,
              setQuotes,
              handleClose,
              handleContinuSale,
            }}
          />
          {/* ----- Footer ----- */}
          <Footer {...{ value }} />
        </Grid>
      </div>
    </div>
  ) : (
    <span className="p-[20px] text-[20px] font-medium text-gray-500">
      Loading...
    </span>
  );
};

export default ViewQuote;
